import React from "react";
import { Button, Icon, Menu, Dropdown, Modal, message } from "antd";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import PageContainer from "layout/default-sidebar-layout/PageContainer";
import slug from "constants/slug";
import { autobind } from "core-decorators";
import createManagerList from "hoc/manager-list";
import createManagerDelete from "hoc/manager-delete";
import Breadcrumb from "../breadcrumb";
import OrganizationSearchForm from "../organization-search-form";
import createLanguageHoc, { langPropTypes } from "../../../hoc/create-lang";
import OrganizationApi from "api/OrganizationApi";
import DynamicTable from "components/elements/dynamic-table";
import styled from "styled-components";
import moment from "moment";
import _ from "lodash";
import { refreshLanguage } from "../../../api/OrganizationApi";

const constStatusColor = {
  expired: "red",
  aboutToExpire: "orange",
  unexpired: "green",
};

const LinkSpan = styled.span`
  color: #000;
  &:hover {
    cursor: pointer;
  }
`;
const IconButton = styled(Icon)`
  padding-right: 5px;
  color: ${(props) => (props.color ? props.color : "#3E90F7")};
`;
const Span = styled.span`
  color: ${(props) => (props.deleted ? "#999999" : "")};
  text-decoration: ${(props) => (props.deleted ? "line-through" : "")};
`;

const SpanStatus = styled.span`
  color: ${(props) => props.color};
`;

@createManagerList({
  apiList: OrganizationApi.getOrganizations,
})
@createManagerDelete({
  apiDelete: OrganizationApi.removeOne,
})
@createLanguageHoc
@autobind
export default class OrganizationList extends React.Component {
  static propTypes = {
    pagination: PropTypes.object,
    pathImg: PropTypes.string,
    onChangePage: PropTypes.func,
    onChangePageSize: PropTypes.func,
    onDeleteItem: PropTypes.func,
    fetchData: PropTypes.func,
    lang: langPropTypes,
  };

  async componentWillMount() {}

  buttonAdd() {
    return (
      <div>
        <Link to={slug.organization.create}>
          <Button type="primary">
            <Icon type="plus" />
            Create
          </Button>
        </Link>
      </div>
    ) 
  }

  renderSearchForm() {
    return (
      <OrganizationSearchForm
        onChangeSearch={(query) => {
          this.props.onChangeSearch(query)
        }}
        initialValues={this.props.data}
      />
    );
  }

  handleRefreshLanguage = async (databaseInfo, t) => {

    try {
      const response = await refreshLanguage({databaseInfo})

      if(_.get(response, 'success')){
        message.success(t("addon.onRefreshLanguage.success"))
      }
      
    } catch (error) {
      message.error(t("addon.onRefreshLanguage.error"))
      console.error({error})
    }
  }

  actionGroup(row) {
    const {
      lang: { t },
    } = this.props;
    // let accountEnable = true
    // if (row.accountStatus && row.accountStatus.enable === false) {
    //   accountEnable = false
    // }
    let dropdown;

    if (row.removeStatus && row.removeStatus.allowed)
      dropdown = this.getMenuIsDeleting(row, t);
    else dropdown = this.getMenuNotDeleting(row, t);

    return (
      <Dropdown overlay={dropdown} trigger={["click"]}>
        <LinkSpan className="ant-dropdown-link">
          <Icon type="setting" style={{ fontSize: 20, color: "#3E90F7" }} />
        </LinkSpan>
      </Dropdown>
    );
  }

  getMenuNotDeleting = (row, t) => {
    return (
      <Menu>
        <Menu.Item key="0">
          <Link to={slug.organization.editWithKey + "/" + row._id}>
            <IconButton type="edit" />
            {t("addon.edit")}
          </Link>
        </Menu.Item>
        <Menu.Item key="1">
          <a onClick={() => this.onDeleteItem(row._id, this.props.fetchData)}>
            <IconButton type="delete" color={"red"} />
            {t("addon.disable")}
          </a>
        </Menu.Item>
        <Menu.Item key="2">
          <Link to={slug.organization.ruleWithKey + "/" + row._id}>
            <IconButton type="usergroup-add" />
            {t("organization.rule.label")}
          </Link>
        </Menu.Item>
        <Menu.Item key="3">
          <Link to={slug.organization.packageInfoWithKey + "/" + row._id}>
            <IconButton type="profile" />
            {t("organization.package.label")}
          </Link>
        </Menu.Item>
        <Menu.Item key="4">
          <div onClick={() => this.handleRefreshLanguage(row.databaseInfo, t)}>
            <IconButton type="retweet" />
            {t("organization.language.action")}
          </div>
        </Menu.Item>
      </Menu>
    );
  }

  getMenuIsDeleting(row, t) {
    return (
      <Menu>
        <Menu.Item key="1">
          <a onClick={() => this.onRestoreItem(row._id, this.props.fetchData)}>
            <IconButton type="reload" />
            {t("addon.restore")}
          </a>
        </Menu.Item>
        {/* <Menu.Item key="2">
          <a
            onClick={() =>
              this.props.onDeleteItem(row._id, this.props.fetchData)
            }
          >
            <IconButton type="close-square-o" color={"red"} />
            {t("addon.remove")}
          </a>
        </Menu.Item> */}
      </Menu>
    );
  }

  async onDeleteItem(_id, callback) {
    const {
      lang: { t },
    } = this.props;
    Modal.confirm({
      title: "Do you want to disable these items?",
      onOk() {
        return new Promise(async (resolve, reject) => {
          const res = await OrganizationApi.deleteOne(_id);
          if (res.success) {
            message.info(t("addon.onDisable.success"));
            callback();
          } else message.error(t("addon.onDisable.error"));
          resolve();
        }).catch(() => console.log("Oops errors!"));
      },
      onCancel() {},
    });
  }

  getStatusContract = (contractExpiredDate, warningExpiredContractBefore) => {
    if (contractExpiredDate == null) return "unexpired";
    // console.log("compare", moment(contractExpiredDate).diff(moment()));
    if (moment() > moment(contractExpiredDate)) {
      return "expired";
    }
    let dateWarning = moment(contractExpiredDate).subtract(
      warningExpiredContractBefore,
      "days"
    );
    if (moment() < dateWarning) {
      return "unexpired";
    } else return "aboutToExpire";
  };

  async onRestoreItem(_id, callback) {
    const {
      lang: { t },
    } = this.props;
    Modal.confirm({
      title: "Do you want to restore these items?",
      onOk() {
        return new Promise(async (resolve, reject) => {
          const res = await OrganizationApi.restoreOne(_id);
          if (res.success) {
            message.info(t("addon.onRestore.success"));
            callback();
          } else message.error(t("addon.onRestore.error"));
          resolve();
        }).catch(() => console.log("Oops errors!"));
      },
      onCancel() {},
    });
  }

  getHead() {
    const {
      lang: { t },
    } = this.props;
    return [
      { content: "#", width: 2 },
      { content: t("organization.form.name.label"), width: 30 },
      { content: t("organization.form.status.label"), width: 10 },
      { content: t("organization.form.addressAPI.label"), width: 20 },
      { content: t("organization.form.databaseInfo.name.label"), width: 20 },
      { content: "Action", width: 15 },
    ];
  }

  getRows() {
    return this.props.dataSource.map((row, index) => {
      let contractExpiredDate = _.get(
        row,
        "packageInfo.contractExpiredDate",
        null
      );
      let warningExpiredContractBefore = _.get(
        row,
        "packageInfo.warningExpiredContractBefore",
        15
      );

      // if(_.isNull(contractExpiredDate))
      let colorStatus =
        constStatusColor[
          this.getStatusContract(
            contractExpiredDate,
            warningExpiredContractBefore
          )
        ];
      return [
        {
          content: (
            <strong>
              {(this.props.pagination.page - 1) *
                this.props.pagination.itemPerPage +
                index +
                1}
            </strong>
          ),
        },
        {
          content: (
            <Span deleted={row.removeStatus && row.removeStatus.allowed}>
              &emsp;{row.name}
            </Span>
          ),
        },
        {
          content: (
            <SpanStatus color={colorStatus}>
              &emsp;
              {contractExpiredDate != null &&
                moment(row.packageInfo.contractExpiredDate).format(
                  "DD/MM/YYYY"
                )}
              {contractExpiredDate == null && (
                <div>không giới hạn</div>
              )}
            </SpanStatus>
          ),
        },
        {
          content: (
            <Span deleted={row.removeStatus && row.removeStatus.allowed}>
              &emsp;{row.addressAPI}
            </Span>
          ),
        },
        {
          content: (
            <Span deleted={row.removeStatus && row.removeStatus.allowed}>
              &emsp;{row.databaseInfo ? row.databaseInfo.name : ""}
            </Span>
          ),
        },
        {
          content: <span>{this.actionGroup(row)}</span>,
        },
      ];
    });
  }

  render() {
    return (
      <PageContainer center={this.renderSearchForm()} right={this.buttonAdd()}>
        <Breadcrumb items={["list"]} />
        <DynamicTable
          loading={this.props.isLoading}
          rows={this.getRows()}
          head={this.getHead()}
          paginationOptions={{
            isSticky: true,
          }}
          onSetPage={this.props.onChangePage}
          pagination={this.props.pagination}
        />
      </PageContainer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/organization/organization-list/index.js